import { TableCell } from '@insurancemenu/imenu-components-lib';
import React from 'react';
import { createStyles } from './styles';

interface Props {
  title?: string;
  data?: string;
  customLayout?: React.ReactNode;
  width?: string;
}

const UsersTableCell: React.FC<Props> = ({ title, data, customLayout, width }) => {
  const classes = createStyles();
  return (
    <TableCell className={classes.userCell} width={width}>
      {customLayout ?? (
        <div>
          <h6 className={classes.title}>{title}</h6>
          <p className={classes.text}> {data}</p>
        </div>
      )}
    </TableCell>
  );
};

export default UsersTableCell;
